import { axiosDS } from '@pp/axios'
import { KEYS, URLS } from 'Modules'
import { ResponseCatalog, RequestParams, ShortDataModel } from 'Models'

export const selectApi = {
	getAllByKey: async (params?: RequestParams, key?: KEYS) => {
		const res = await axiosDS().get<ResponseCatalog<ShortDataModel>>(URLS[key], {
			params,
		})
		return res.data
	},
	getDictByKey: async (key?: KEYS) => {
		const res = await axiosDS().get<Record<KEYS, ShortDataModel> | ShortDataModel[] | string[]>(
			URLS[key]
		)
		return res.data
	},
}
